import { AxiosResponse } from "axios";
import { GenericService } from "./Generic.service";

export class PersonAllergieService extends GenericService<string> {
  readonly URI: string = "PessoaAlergia";

  constructor() {
    super();
    this.setUri(this.URI);
  }

  public async getAll() {
    return await super.getByResource("", { PageSize: 500 });
  }

  public async getAllergiesPerson({
    id,
    alergeno,
    ...rest
  }: {
    id?: string;
    alergeno?: string;
    tipo?: string;
  }) {
    return await super.getByResource<AxiosResponse<[]>>(`pessoa/${id}`, {
      PageSize: 500,
      alergeno: alergeno ? alergeno : undefined,
      ...rest,
    });
  }

  public async getTypesAllergies() {
    return await super.getByResource("TiposAlergia");
  }

  public async deleteAllergiePerson(id: string) {
    return await super.deleteByResource("", id);
  }

  public async addAllergier(data: any) {
    return await super.post(data);
  }

}
